import ActionBarItem from '@rio-cloud/rio-uikit/ActionBarItem';
import Button from '@rio-cloud/rio-uikit/Button';
import Icon from '@rio-cloud/rio-uikit/Icon';
import { selectCurrentUser, selectIsSigningOut, signOut } from 'features/auth/authSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';

const UserMenu = () => {
    const dispatch = useAppDispatch();
    const user = useAppSelector(selectCurrentUser);
    const isLoggingOut = useAppSelector(selectIsSigningOut);

    if (user === null) {
        return null;
    }

    // The route guard owns the redirect, so this works for providers that sign out via redirect too.
    const handleLogout = () => {
        void dispatch(signOut());
    };

    return (
        <ActionBarItem id='userMenu' popoverWidth={250} hidePopoverOnClick={false}>
            <ActionBarItem.Icon>
                <Icon iconName='user' className='icon' />
            </ActionBarItem.Icon>
            <ActionBarItem.Popover>
                <ActionBarItem.List>
                    <div className='padding-15'>
                        <div className='text-medium'>{`${user.firstName} ${user.lastName}`}</div>
                        <div className='text-size-12 text-color-gray word-break-all'>{user.email}</div>
                    </div>
                    <ActionBarItem.ListSeparator />
                    <ActionBarItem.ListItem>
                        <Button
                            bsStyle={Button.DEFAULT}
                            variant={Button.VARIANT_LINK}
                            iconName='rioglyph-logout'
                            disabled={isLoggingOut}
                            onClick={handleLogout}
                        >
                            <span className='hover-text-decoration-none'>
                                {isLoggingOut ? 'Signing out' : 'Logout'}
                            </span>
                        </Button>
                    </ActionBarItem.ListItem>
                </ActionBarItem.List>
            </ActionBarItem.Popover>
        </ActionBarItem>
    );
};

export default UserMenu;
